import { chartMono, colors } from '../theme/tokens';
import type { TooltipComponentOption } from './echarts';

export const AXIS_TEXT = { color: colors.textSecondary, fontFamily: chartMono, fontSize: 9 };

interface ChartTooltip {
  phone: boolean;
  formatter: (params: unknown) => string;
  axisPointer?: TooltipComponentOption['axisPointer'];
  fontSize?: number;
  padding?: [number, number];
}

export function chartTooltip({
  phone, formatter, axisPointer = { type: 'line', lineStyle: { color: colors.ink, width: 1 } }, fontSize = 10, padding = [6, 8],
}: ChartTooltip): TooltipComponentOption {
  return {
    // echarts' tooltip typing omits 'mousemove|click', which it accepts at runtime (axisPointer's type includes it)
    ...(phone ? { triggerOn: 'mousemove|click' as 'mousemove|click|mousewheel', confine: true } : {}),
    trigger: 'axis', backgroundColor: colors.ink, borderWidth: 0, padding,
    textStyle: { color: colors.paper, fontFamily: chartMono, fontSize },
    axisPointer,
    formatter,
  };
}

export function dataIndexOf(params: unknown): number {
  const first: unknown = Array.isArray(params) ? params[0] : params;
  if (typeof first === 'object' && first !== null && 'dataIndex' in first && typeof first.dataIndex === 'number') {
    return first.dataIndex;
  }
  return -1;
}

export function pointValue(params: unknown): number | null {
  const first: unknown = Array.isArray(params) ? params[0] : params;
  if (typeof first !== 'object' || first === null || !('value' in first) || !Array.isArray(first.value)) return null;
  const value: unknown = first.value[1];
  return typeof value === 'number' ? value : null;
}
